import { render, staticRenderFns } from "./DataWell.vue?vue&type=template&id=176fd834&scoped=true&lang=pug&"
import script from "./DataWell.vue?vue&type=script&lang=js&"
export * from "./DataWell.vue?vue&type=script&lang=js&"
import style0 from "./DataWell.vue?vue&type=style&index=0&id=176fd834&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176fd834",
  null
  
)

export default component.exports